/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useEffect } from 'react';

import { getClientAuthProviderConfig } from '@/lib/auth-provider';
import { getEntraAccessToken } from '@/lib/msal';
import { useAuth } from '@/hooks/useAuth';

export const SessionDetails = ({ session }: { session: string }) => {
  const { setAuth } = useAuth();

  useEffect(() => {
    // entra_id has no server-rendered session (it's always null), so the
    // AuthContext must instead be populated from the MSAL token directly.
    if (!getClientAuthProviderConfig().browserManagedSession) {
      setAuth(JSON.parse(session));
      return;
    }

    let cancelled = false;

    getEntraAccessToken()
      .then((accessToken) => {
        if (!cancelled) setAuth({ accessToken });
      })
      .catch(() => {
        // not signed in yet; auth stays null until MSAL login completes
      });

    return () => {
      cancelled = true;
    };
  }, [session]);

  return <></>;
};
